import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ITag } from 'entities/tags';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootState} from 'src/store/index';

export interface ITagsState {
  tags: ITag[];
  currentTags: ITag[];
  hasInvalidTags: boolean;
}

const initialState: ITagsState = {
  tags: [],
  currentTags: [],
  hasInvalidTags: false,
};

const tagsSlice = createSlice({
  extraReducers: {
    [HYDRATE]: (state, {payload}: PayloadAction<IRootState>) => {
      if (!payload) {
        return state;
      }

      return payload['tags'];
    },
  },
  name: 'tags',
  initialState,
  reducers: {
    /** Устанавливает базовые теги */
    setTags: (state, action: PayloadAction<ITag[]>) => {
      state.tags = action.payload;
      state.currentTags = [];
      state.hasInvalidTags = false;
    },
    /** Устанавливает текущие (примененные) теги */
    setCurrentTags: (state, action: PayloadAction<ITag[]>) => {
      state.currentTags = action.payload;
    },
    /** Указывает, что в урле есть невалидный тег */
    markTagsAsInvalid: (state) => {
      state.hasInvalidTags = true;
    },
    /** Делает ресет стейта тегов */
    resetTags: (state) => {
      state.currentTags = [];
      state.tags = [];
      state.hasInvalidTags = false;
    },
  },
});

export const { setTags, setCurrentTags, markTagsAsInvalid } = tagsSlice.actions;

export default tagsSlice.reducer;
